import { NgModule, LOCALE_ID, PLATFORM_ID, Injector } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';

import { ClientRoutingModule } from './client-routing.module';
import { ClientPageComponent } from './client-page/client-page.component';
import { ClientStoresComponent } from './client-stores/client-stores.component';
import { ClientServicesComponent } from './client-services/client-services.component';
import { ClientProvidersComponent } from './client-providers/client-providers.component';
import { ClientDayComponent } from './client-day/client-day.component';
import { ClientTimeComponent } from './client-time/client-time.component';
import { RouterModule } from '@angular/router';
import { ClientConfirmComponent } from './client-confirm/client-confirm.component';
import { ClientComponent } from './client.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientSuccessComponent } from './client-success/client-success.component';
import { ClipboardModule } from 'ngx-clipboard';
import { ClientCancelBookingComponent } from './client-cancel-booking/client-cancel-booking.component';
import { SharedWithClientModule } from '../shared-with-client/shared-with-client.module';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { ToolsService } from '../core/services/tools.service';
import { TranslateBrowserLoader } from '../core/translate-browser.service';
import { TransferState } from '@angular/platform-browser';
import { TranslateServerService } from '../core/translate-server.service';
import { environment } from '../../environments/environment';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';
import { ModalModule } from 'ngx-bootstrap/modal';
import { IntlService } from '../core/services/intl.service';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ClientPayBookingComponent } from './client-pay-booking/client-pay-booking.component';

export function createTranslateLoader(http: HttpClient, transferState: TransferState) {
  // return new TranslateHttpLoader(http, './assets/i18n-lang/', '.json');
  if (!environment.production) {
    return new TranslateBrowserLoader(transferState, http);
  } else {
    return new TranslateServerService(transferState);
  }
}

const COMPONENTS = [
  ClientPageComponent,
  ClientStoresComponent,
  ClientServicesComponent,
  ClientProvidersComponent,
  ClientDayComponent,
  ClientTimeComponent,
  ClientConfirmComponent,
  ClientComponent,
  ClientSuccessComponent,
  ClientCancelBookingComponent,
  ClientPayBookingComponent
];

@NgModule({
  imports: [
    CommonModule,
    ClientRoutingModule,
    SharedWithClientModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    NgxIntlTelInputModule,
    FormsModule,
    ReactiveFormsModule,
    ClipboardModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, TransferState],
      },
    }),
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: (intlService) => {
        return intlService.getCurrentLanguage();
      },
      deps: [IntlService],
    },
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    COMPONENTS,
  ]
})
export class ClientModule {}
